import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../Components/baseUrl";
import Menu from "../../Components/Menu";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import InfiniteScroll from "react-infinite-scroll-component";
import GiftModal from "../../Components/GiftModal";
import DescriptionModal from "../../Components/DescriptionModal";

const EditOrder = () => {
    const navigate = useNavigate();
    let token;
    let user;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
        user = localStorage.getItem("user");
    }
    useEffect(() => {
        document.title = "پایا | محصولات";
        token == null && navigate("/login", { replace: true });
    }, []);
    const { orderId } = useParams();
    const [showFilter, setShowFilter] = useState(false);
    const [activeMenu, setActiveMenu] = useState(0);
    const [productList, setProductList] = useState([]);
    const [pages, setPages] = useState([]);
    const [numPages, setNumPages] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [cartLoading, setCartLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [catList, setCatList] = useState([]);
    const [brandList, setBrandList] = useState([]);
    const [selectedCat, setSelectedCat] = useState("");
    const [selectedBrand, setSelectedBrand] = useState();
    const [allAmount, setAllAmount] = useState(0);
    // useEffect(() => {
    //     let config = {
    //         url: `${baseUrl}/categories`,
    //         method: "GET",
    //     };
    //     axios(config)
    //         .then((res) => {
    //             setCatList(res.data.data);
    //         })
    //         .catch((err) => {
    //             setCartLoading(false);
    //             toast.error(err.response.data.message, {
    //                 position: "top-center",
    //                 autoClose: 5000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //             });
    //         });
    // }, []);
    // const [shopCatList, setShopCatList] = useState([]);
    // useEffect(() => {
    //     let config = {
    //         url: `${baseUrl}/company-categories`,
    //         method: "GET",
    //     };
    //     axios(config)
    //         .then((res) => {
    //             setShopCatList(res.data.data);
    //         })
    //         .catch((err) => {
    //             setCartLoading(false);
    //             toast.error(err.response.data.message, {
    //                 position: "top-center",
    //                 autoClose: 5000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //             });
    //         });
    // }, []);
    // const brandHandler = (id) => {
    //     setSelectedCat(id);
    //     let config = {
    //         url: `${baseUrl}/brands?category_id=${id}`,
    //         method: "GET",
    //     };
    //     axios(config)
    //         .then((res) => {
    //             setBrandList(res.data.data);
    //             setShowFilterTab(2);
    //         })
    //         .catch((err) => {
    //             setCartLoading(false);
    //             toast.error(err.response.data.message, {
    //                 position: "top-center",
    //                 autoClose: 5000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //             });
    //         });
    // };
    const productHandler = () => {
        let config = {
            url: `${baseUrl}/orders/${orderId}/edit?count=300`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                setShowConfirm(false);
                setShowFilter(false);
                setCartLoading(false);
                res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.products &&
                    setProductList(
                        res.data.data.products.map((item) => ({
                            ...item,
                            num: item.order_count,
                        }))
                    );
                const totalAmount = res.data.data.products.reduce(
                    (accumulator, item) => {
                        if (item.order_count !== 0) {
                            return (
                                accumulator +
                                Number(item.order_count) *
                                    Number(item.unit_price)
                            );
                        } else {
                            return accumulator;
                        }
                    },
                    0
                );

                setAllAmount(totalAmount);
                res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.paginate &&
                    setPages(res.data.data.paginate);
            })
            .catch((err) => {
                setShowConfirm(false);
                setShowFilter(false);
                setCartLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        productHandler();
    }, []);
    useEffect(() => {
        let total = pages.totalItems;
        const totalPagesCount = Math.ceil(total / pages.itemsPerPage);
        setNumPages(
            Array.from({ length: totalPagesCount }, (_, index) => index + 1)
        );
    }, [pages]);
    const increaseHandler = (item) => {
        const productToUpdate = productList.find((c) => c.id === item.id);
        if (item.max_order) {
            if (
                productToUpdate.num < item.max_order &&
                productToUpdate.num < item.inventory
            ) {
                let i = productList;
                i.find((c) => c.id === item.id).num++;
                setProductList(i);
                setAllAmount(allAmount + Number(item.unit_price));
            } else {
                toast.error("تعداد سفارش بیشتر از حد مجاز.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } else {
            if (productToUpdate.num < item.inventory) {
                let i = productList;
                i.find((c) => c.id === item.id).num++;
                setProductList(i);
                setAllAmount(allAmount + Number(item.unit_price));
            } else {
                toast.error("تعداد سفارش بیشتر از حد مجاز.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    };
    const decreaseHandler = (item) => {
        let i = productList;
        const foundItem = i.find((c) => c.id === item.id);
        foundItem.num >= 0 && --foundItem.num;
        foundItem.num >= 0 && setAllAmount(allAmount - Number(item.unit_price));
        setProductList(i);
    };
    const [showConfirm, setShowConfirm] = useState(false);
    const addToCartHandler = (e) => {
        setShowConfirm(false);
        setCartLoading(true);
        let items = [];
        productList &&
            productList.map((item) => {
                item.num &&
                    item.num !== 0 &&
                    items.push({
                        company_id: item.company_id,
                        product_id: item.id,
                        product_count: item.num,
                    });
            });
        let data = {
            orders: items,
        };
        let config = {
            url: `${baseUrl}/orders/${orderId}/update`,
            method: "PATCH",
            data: data,
        };
        axios(config)
            .then((resp) => {
                toast.success("با موفقیت به سبد خرید اضافه شد", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setCartLoading(false);
                setTimeout(() => {
                    navigate("/panel/factor/" + orderId);
                }, 2000);
            })
            .catch((err) => {
                setCartLoading(false);
                err.response &&
                    err.response.data &&
                    toast.error(err.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
            });
    };

    const pageHandler = () => {
        let data = new FormData();
        let config = {
            url: `${baseUrl}/orders/${orderId}/edit?count=300&page=${pages.nextPage}`,
            method: "GET",
        };
        numPages.length >= pages.nextPage &&
            axios(config)
                .then((res) => {
                    res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.products &&
                        setProductList((prevData) => [
                            ...prevData,
                            ...res.data.data.products.map((item) => ({
                                ...item,
                                num: item.order_count,
                            })),
                        ]);
                    const totalAmount = res.data.data.products.reduce(
                        (accumulator, item) => {
                            if (item.order_count !== 0) {
                                return (
                                    accumulator +
                                    Number(item.order_count) *
                                        Number(item.unit_price)
                                );
                            } else {
                                return accumulator;
                            }
                        },
                        0
                    );
                    res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.paginate &&
                        setPages(res.data.data.paginate);
                })
                .catch((err) => {
                    toast.error(err.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                });
        numPages.length < pages.nextPage && setHasMore(false);
    };

    // Filter
    const [showFilterTab, setShowFilterTab] = useState(0);
    const [showInventory, setShowInventory] = useState(false);
    const [gift, setGift] = useState([]);
    const [showGiftModal, setShowGiftModal] = useState(false);
    const [description, setDescription] = useState([]);
    const [showDescription, setShowDescription] = useState(false);
    return (
        <div className="container">
            {showGiftModal && <GiftModal gift={gift} />}
            {showDescription && <DescriptionModal description={description} />}
            {showConfirm && (
                <div className="logout-modal">
                    <h2>خروج</h2>
                    <span className="ques">
                        آیا مایلید سفارش فعلی خود را ذخیره کنید؟
                    </span>
                    <div className="btns">
                        <button
                            onClick={() => {
                                addToCartHandler();
                            }}
                            className="stay"
                        >
                            ذخیره
                        </button>
                        <button
                            onClick={() => setShowConfirm(false)}
                            className="exit"
                        >
                            لغو
                        </button>
                    </div>
                </div>
            )}
            <div className="product-main">
                {(activeMenu !== 0 ||
                    showFilter ||
                    showGiftModal ||
                    showDescription) && (
                    <div
                        onClick={() => {
                            setActiveMenu(0);
                            setShowFilter(false);
                            setShowGiftModal(false);
                            setShowDescription(false);
                        }}
                        id="bg_gray"
                        className="bg-gray"
                    ></div>
                )}
                {showFilter && (
                    <div id="filter_modal" className="filter-modal">
                        <div className="filter-modal-head">
                            <svg
                                className="orang-filter"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56"
                                    stroke="#FF0000"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    opacity="0.4"
                                    d="M21.89 12C21.89 17.52 17.41 22 11.89 22C6.37 22 3 16.44 3 16.44M3 16.44H7.52M3 16.44V21.44"
                                    stroke="#FF0000"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <h2>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={() => {
                                    setShowFilter(false);
                                    allAmount !== 0
                                        ? setShowConfirm(true)
                                        : productHandler();
                                }}
                            >
                                <path
                                    d="M21 7L11 7"
                                    stroke="#3BA7E4"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                    stroke="#3BA7E4"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M3 17L13 17"
                                    stroke="#3BA7E4"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                    stroke="#3BA7E4"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                            فیلتر
                        </h2>
                        <button
                            id="show_invent_btn"
                            onClick={() => setShowInventory(!showInventory)}
                            className={
                                showInventory
                                    ? "inventory-tbn to-center-btn"
                                    : "inventory-tbn "
                            }
                        >
                            <span className="btn-in">
                                <svg
                                    width="7"
                                    height="7"
                                    viewBox="0 0 7 7"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="3.5"
                                        cy="3.5"
                                        r="3.5"
                                        fill="#979797"
                                    />
                                </svg>
                                فقط کالا های موجود
                            </span>
                        </button>
                        {/* <button
                            onClick={() => {
                                showFilterTab !== 1
                                    ? setShowFilterTab(1)
                                    : setShowFilterTab(0);
                            }}
                            className="filter-btn"
                        >
                            انتخاب دسته بندی
                            <svg
                                width="14"
                                height="11"
                                viewBox="0 0 14 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
                                    fill="#8C8C8C"
                                />
                            </svg>
                        </button>
                        <div
                            id="filter_tab_1"
                            className={
                                showFilterTab !== 1
                                    ? "filter-items"
                                    : "filter-items show"
                            }
                        >
                            {catList &&
                                catList.length !== 0 &&
                                catList.map((item) => {
                                    return (
                                        <button
                                            onClick={() =>
                                                brandHandler(item.id)
                                            }
                                            key={item.id}
                                            className={
                                                item.id == selectedCat &&
                                                "bg-info"
                                            }
                                        >
                                            {item.title}
                                        </button>
                                    );
                                })}
                        </div>
                        <button
                            onClick={() => {
                                showFilterTab !== 2
                                    ? setShowFilterTab(2)
                                    : setShowFilterTab(0);
                            }}
                            className="filter-btn"
                        >
                            انتخاب برند
                            <svg
                                width="14"
                                height="11"
                                viewBox="0 0 14 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
                                    fill="#8C8C8C"
                                />
                            </svg>
                        </button>
                        <div
                            id="filter_tab_2"
                            className={
                                showFilterTab !== 2
                                    ? "filter-items"
                                    : "filter-items show"
                            }
                        >
                            {brandList &&
                                brandList.length !== 0 &&
                                brandList.map((item) => {
                                    return (
                                        <button
                                            className={
                                                item.id == selectedBrand &&
                                                "bg-info"
                                            }
                                            onClick={() =>
                                                setSelectedBrand(item.id)
                                            }
                                            key={item.id}
                                        >
                                            {item.name}
                                        </button>
                                    );
                                })}
                        </div>
                        <button
                                onClick={() => {
                                    showFilterTab !== 3
                                        ? setShowFilterTab(3)
                                        : setShowFilterTab(0);
                                }}
                                className="filter-btn"
                            >
                                انتخاب دسته بندی داخلی
                                <svg
                                    width="14"
                                    height="11"
                                    viewBox="0 0 14 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
                                        fill="#8C8C8C"
                                    />
                                </svg>
                            </button>
                            <div
                                id="filter_tab_1"
                                className={
                                    showFilterTab !== 3
                                        ? "filter-items"
                                        : "filter-items show"
                                }
                            >
                                {shopCatList &&
                                    shopCatList.length !== 0 &&
                                    shopCatList.map((item) => {
                                        return (
                                            <button
                                                onClick={() =>
                                                    brandHandler(item.id)
                                                }
                                                key={item.id}
                                                className={
                                                    item.id == selectedCat &&
                                                    "bg-info"
                                                }
                                            >
                                                {item.title}
                                            </button>
                                        );
                                    })}
                            </div> */}
                    </div>
                )}
                <div className="search-box" id="search_box">
                    <div className="pos-rel-search">
                        <input
                            onChange={(e) => setSearchText(e.target.value)}
                            type="text"
                            value={searchText}
                            placeholder="جستجو کنید"
                        />
                        <svg
                            onClick={() => {
                                allAmount !== 0
                                    ? setShowConfirm(true)
                                    : productHandler();
                            }}
                            className="search-svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M16.5 16.958L21.5 21.958"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>

                    <div
                        className="svg-rec"
                        onClick={() => setShowFilter(true)}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M21 7L11 7"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M3 17L13 17"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>
                <div className="product-alert">
                    <div className="d-flex-center color-b">
                        <svg
                            width="35"
                            height="35"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6.92705 20.373C6.72288 22.7501 8.60412 24.7918 10.9958 24.7918H26.5271C28.6271 24.7918 30.4645 23.071 30.625 20.9855L31.4125 10.048C31.5875 7.62721 29.75 5.65845 27.3145 5.65845H8.48747"
                                stroke="#e16057"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M2.91663 2.91675H5.45413C7.02913 2.91675 8.26871 4.273 8.13746 5.83341L7.4083 14.6563"
                                stroke="#e16057"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M23.6979 32.0833C24.7047 32.0833 25.5208 31.2672 25.5208 30.2604C25.5208 29.2536 24.7047 28.4375 23.6979 28.4375C22.6911 28.4375 21.875 29.2536 21.875 30.2604C21.875 31.2672 22.6911 32.0833 23.6979 32.0833Z"
                                stroke="#e16057"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M12.0313 32.0833C13.0381 32.0833 13.8542 31.2672 13.8542 30.2604C13.8542 29.2536 13.0381 28.4375 12.0313 28.4375C11.0245 28.4375 10.2084 29.2536 10.2084 30.2604C10.2084 31.2672 11.0245 32.0833 12.0313 32.0833Z"
                                stroke="#e16057"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M13.125 11.6667H30.625"
                                stroke="#e16057"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        سفارشات جدید
                    </div>
                    <span>{allAmount.toLocaleString()} تومان </span>
                </div>
                <InfiniteScroll
                    dataLength={productList.length}
                    next={pageHandler}
                    hasMore={hasMore}
                    loader={
                        productList.length !== 0 && (
                            <div className="mx-auto d-flex justify-content-center mt-4">
                                <img
                                    src="/assets/images/loading.gif"
                                    width={40}
                                />
                            </div>
                        )
                    }
                >
                    {productList !== undefined &&
                        productList !== null &&
                        productList.length !== 0 &&
                        productList.map((item) => {
                            return (
                                <div key={item.id} className="product-card">
                                    <div className="row-1">
                                        <div className="img-div">
                                            <img src={item.Image} alt="" />
                                        </div>
                                        <div>
                                            <div className="marquee">
                                                <h4
                                                    className={
                                                        item.name.length < 13
                                                            ? "name"
                                                            : item.name.length <
                                                              25
                                                            ? "name moving-2"
                                                            : "name moving"
                                                    }
                                                >
                                                    <span>{item.name}</span>
                                                </h4>
                                            </div>
                                            <div className="d-flex-center">
                                                <span className="price-span-1">
                                                    قیمت واحد:
                                                </span>
                                                <span className="price-span-2">
                                                    {Number(
                                                        item.unit_price
                                                    ).toLocaleString()}{" "}
                                                    تومان
                                                </span>
                                            </div>
                                            <div className="d-flex-center">
                                                <span className="muted-span-1">
                                                    قیمت فروشگاه:
                                                </span>
                                                <span className="muted-span-2">
                                                    {Number(
                                                        item.store_price
                                                    ).toLocaleString()}{" "}
                                                    تومان
                                                </span>
                                            </div>
                                            <div className="d-flex-center">
                                                <span className="muted-span-1">
                                                    قیمت مصرف کننده:
                                                </span>
                                                <span className="muted-span-2">
                                                    {Number(
                                                        item.consumer_price
                                                    ).toLocaleString()}{" "}
                                                    تومان
                                                </span>
                                            </div>
                                            <div className="d-flex-center">
                                                <span className="muted-span-1">
                                                    تعداد در واحد:
                                                </span>
                                                <span className="muted-span-2">
                                                    {item.unit_count} جعبه
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="gift"
                                            onClick={() => {
                                                setGift(item.Gifts);
                                                setShowGiftModal(true);
                                            }}
                                        >
                                            <svg
                                                width="18"
                                                height="18"
                                                viewBox="0 0 18 18"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M14.9775 7.5H2.97754V13.5C2.97754 15.75 3.72754 16.5 5.97754 16.5H11.9775C14.2275 16.5 14.9775 15.75 14.9775 13.5V7.5Z"
                                                    stroke="#3BA7E4"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M16.125 5.25V6C16.125 6.825 15.7275 7.5 14.625 7.5H3.375C2.2275 7.5 1.875 6.825 1.875 6V5.25C1.875 4.425 2.2275 3.75 3.375 3.75H14.625C15.7275 3.75 16.125 4.425 16.125 5.25Z"
                                                    stroke="#3BA7E4"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.4"
                                                    d="M8.73008 3.75008H4.59008C4.33508 3.47258 4.34258 3.04508 4.61258 2.77508L5.67758 1.71008C5.95508 1.43258 6.41258 1.43258 6.69008 1.71008L8.73008 3.75008Z"
                                                    stroke="#3BA7E4"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.4"
                                                    d="M13.4025 3.75008H9.26245L11.3025 1.71008C11.58 1.43258 12.0375 1.43258 12.315 1.71008L13.38 2.77508C13.65 3.04508 13.6575 3.47258 13.4025 3.75008Z"
                                                    stroke="#3BA7E4"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.4"
                                                    d="M6.70508 7.5V11.355C6.70508 11.955 7.36508 12.3075 7.86758 11.985L8.57258 11.52C8.82758 11.355 9.15008 11.355 9.39758 11.52L10.0651 11.97C10.5601 12.3 11.2276 11.9475 11.2276 11.3475V7.5H6.70508Z"
                                                    stroke="#3BA7E4"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="row-2">
                                        <div className="count">
                                            <button
                                                className="count-btn plus"
                                                aria-label="Increase by one"
                                                onClick={() =>
                                                    increaseHandler(item)
                                                }
                                            >
                                                <svg
                                                    width="15"
                                                    height="15"
                                                    viewBox="0 0 15 15"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.5 1L7.5 14"
                                                        stroke="#0085FF"
                                                        strokeLinecap="round"
                                                    />
                                                    <path
                                                        d="M14 7.5L1 7.5"
                                                        stroke="#0085FF"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                            </button>
                                            <span className="num number dim">
                                                {item.num}
                                            </span>
                                            <button
                                                onClick={() =>
                                                    item.num > 0 &&
                                                    decreaseHandler(item)
                                                }
                                                className="count-btn"
                                                aria-label="Decrease by one"
                                            >
                                                <svg
                                                    width="15"
                                                    height="1"
                                                    viewBox="0 0 15 1"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M14 0.5L1 0.5"
                                                        stroke="#0085FF"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                        <div className="inventory">
                                            <svg
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M10.9999 4.58325L6.92992 1.83325L1.83325 5.49992L5.90325 8.24992L10.9999 4.58325Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11 4.58325L15.07 1.83325L20.1667 5.49992L16.0967 8.24992L11 4.58325Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M10.9999 12.8334L6.92992 15.5834L1.83325 11.9167L5.90325 9.16675L10.9999 12.8334Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11 12.8334L15.07 15.5834L20.1667 11.9167L16.0967 9.16675L11 12.8334Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.4"
                                                    d="M17.4166 14.2083V17.2057L11.3849 19.9924C11.1374 20.1024 10.8624 20.1024 10.6149 19.9924L4.58325 17.2057V14.2083"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            <span>موجودی:</span>
                                            <span className="inv-num">
                                                {item.inventory}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex-center pro-row">
                                        <div className="d-flex-center">
                                            <div className="price-blue min-w-160">
                                                <svg
                                                    width="21"
                                                    height="21"
                                                    viewBox="0 0 21 21"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <g opacity="0.4">
                                                        <path
                                                            d="M7.4375 12.4688C7.4375 14.1487 8.82 15.5312 10.5 15.5312C12.18 15.5312 13.5625 14.1487 13.5625 12.4688"
                                                            stroke="#0085FF"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M7.70827 1.75L4.54077 4.92625"
                                                            stroke="#0085FF"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M13.2908 1.75L16.4583 4.92625"
                                                            stroke="#0085FF"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </g>
                                                    <path
                                                        d="M1.75 6.86865C1.75 5.2499 2.61625 5.11865 3.6925 5.11865H17.3075C18.3838 5.11865 19.25 5.2499 19.25 6.86865C19.25 8.7499 18.3838 8.61865 17.3075 8.61865H3.6925C2.61625 8.61865 1.75 8.7499 1.75 6.86865Z"
                                                        stroke="#0085FF"
                                                        strokeWidth="1.5"
                                                    />
                                                    <path
                                                        d="M3.0625 8.75L4.29625 16.31C4.57625 18.0075 5.25 19.25 7.7525 19.25H13.0288C15.75 19.25 16.1525 18.06 16.4675 16.415L17.9375 8.75"
                                                        stroke="#0085FF"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                                <span className="price-n">
                                                    {Number(
                                                        item.unit_price *
                                                            item.num
                                                    ).toLocaleString()}
                                                </span>
                                                <span>تومان</span>
                                            </div>
                                            {item.discount_percent
                                                ? item.discount_percent !==
                                                      0 && (
                                                      <span className="discount">
                                                          {
                                                              item.discount_percent
                                                          }
                                                          %
                                                      </span>
                                                  )
                                                : ""}
                                        </div>
                                        <svg
                                            className="mt-10"
                                            width="48"
                                            height="28"
                                            viewBox="0 0 48 28"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                                width="48"
                                                height="28"
                                                rx="14"
                                                fill="#CCEDFF"
                                            />
                                            <path
                                                d="M28.96 8.16992C30.96 9.55992 32.34 11.7699 32.62 14.3199"
                                                stroke="#3BA7E4"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M15.49 14.37C15.75 11.83 17.11 9.61997 19.09 8.21997"
                                                stroke="#3BA7E4"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M20.1899 22.9399C21.3499 23.5299 22.6699 23.8599 24.0599 23.8599C25.3999 23.8599 26.6599 23.5599 27.7899 23.0099"
                                                stroke="#3BA7E4"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M21.28 6.91989C21.28 8.44989 22.52 9.69989 24.06 9.69989C25.6 9.69989 26.84 8.45989 26.84 6.91989C26.84 5.37989 25.6 4.13989 24.06 4.13989"
                                                stroke="#3BA7E4"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M16.83 21.9201C18.3654 21.9201 19.61 20.6755 19.61 19.1401C19.61 17.6048 18.3654 16.3601 16.83 16.3601C15.2947 16.3601 14.05 17.6048 14.05 19.1401C14.05 20.6755 15.2947 21.9201 16.83 21.9201Z"
                                                stroke="#3BA7E4"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M33.9399 19.1401C33.9399 17.6101 32.6999 16.3601 31.1599 16.3601C29.6199 16.3601 28.3799 17.6001 28.3799 19.1401C28.3799 20.6801 29.6199 21.9201 31.1599 21.9201"
                                                stroke="#3BA7E4"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    {item.description && (
                                        <div className="info-div">
                                            <svg
                                                onClick={() => {
                                                    setDescription(
                                                        item.description
                                                    );
                                                    setShowDescription(true);
                                                }}
                                                width="25"
                                                height="25"
                                                viewBox="0 0 25 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M12.4999 22.9166C18.2291 22.9166 22.9166 18.2291 22.9166 12.4999C22.9166 6.77075 18.2291 2.08325 12.4999 2.08325C6.77075 2.08325 2.08325 6.77075 2.08325 12.4999C2.08325 18.2291 6.77075 22.9166 12.4999 22.9166Z"
                                                    stroke="#FF9A51"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.6"
                                                    d="M12.5 8.33325V13.5416"
                                                    stroke="#FF9A51"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.6"
                                                    d="M12.4944 16.6667H12.5037"
                                                    stroke="#FF9A51"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                </InfiniteScroll>
                <div className=" mt-4"></div>
                {cartLoading ? (
                    <div className="add-to-cart">
                        <div className="mx-auto d-flex justify-content-center">
                            <img src="/assets/images/loading.gif" width={20} />
                        </div>
                    </div>
                ) : (
                    <div onClick={addToCartHandler} className="add-to-cart">
                        ویرایش فاکتور
                    </div>
                )}
                <Menu active="shop" />
            </div>
        </div>
    );
};

export default EditOrder;
